import { Text } from "@aurem/ui";
import { ReactNode } from "react";

type DevToolbarCardProps = {
  title: string;
  children: ReactNode;
  testId?: string;
};

export const DevToolbarCard = ({
  title,
  children,
  testId,
}: DevToolbarCardProps) => (
  <div
    className="border border-gray200 rounded-lg p-3 bg-gray50"
    data-e2e-id={testId}
  >
    <Text className="mb-2">{title}</Text>
    {children}
  </div>
);
